import { View } from "binder"
import { ToolStatusManipulationViewModel, ToolStatus } from "./toolStatusManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class ToolStatusManipulationView extends View<ToolStatusManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-23966BDF-FD97-40DF-BEE0-6D2F4DFA2EFA"
    }
    loadHtml(): string {
        let element = require('./toolStatusManipulation.html').default;
        let style = require('./toolStatusManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolStatuses(v: ToolStatus) { this._toolStatuses = v; } public get toolStatuses(): ToolStatus { return this._toolStatuses; } private _toolStatuses: ToolStatus;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
